<template>
  <technical-page-wrapper>
    <technical-section
      :title="t('serviceIsNotAvailableInYourRegion')"
      :description="t('serviceIsCurrentlyNotAvailableInYourRegion')"
      image="/img/empty/regional-restrict.webp"
    >
      <template #sup>
        <chips-item :item="country" disabled style="margin-top: 16px" />
      </template>
    </technical-section>
  </technical-page-wrapper>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import TechnicalPageWrapper from 'components/technical/TechnicalPageWrapper.vue'
import TechnicalSection from 'components/technical/TechnicalSection.vue'
import ChipsItem from 'components/ui/chips/ChipsItem.vue'
import { useServerStatusStore } from 'stores/server-status/index.js'
import { useSiteInfoStore } from 'stores/site-info/index.js'

const { t } = useI18n()

const site = useSiteInfoStore()
const serverStore = useServerStatusStore()

function country2flag(countryCode) {
  return countryCode
    .toUpperCase()
    .split('')
    .map((char) => String.fromCodePoint(char.charCodeAt(0) + 0x1f1a5))
    .join('')
}

const country = computed(() => ({
  name:
    country2flag(serverStore.geo.country || site.getRealRegion) + ' ' + (serverStore.geo.client_ip || site.getUserIp),
}))
</script>

<style scoped lang="scss"></style>
